var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',[_vm._v(_vm._s(_vm.sliderData))]),(
      _vm.answer.answer_object &&
        _vm.answer.answer_object.comment &&
        _vm.answer.answer_object.comment.length
    )?_c('p',[_c('span',{staticClass:"comments",style:({ color: _vm.$store.getters.theme[3] })},[_vm._v(" "+_vm._s(_vm.translation.answer_task.comments)+" ")]),_vm._v(" "+_vm._s(_vm.answer.answer_object.comment)+" ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }